export default "* (Grund)bevægelser\n* Samarbejde\n* Udfordring\n";